import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import * as FileSaver from 'file-saver';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddAdministrateursComponent } from '../add-administrateurs/add-administrateurs.component';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { UpdateAdministrateurComponent } from '../update-administrateur/update-administrateur.component';

@Component({
  selector: 'app-list-administrateurs',
  templateUrl: './list-administrateurs.component.html',
  styleUrl: './list-administrateurs.component.scss'
})
export class ListAdministrateursComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  isDisabled: boolean = false;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  displaySuspendDialog: boolean = false;
  suspendReason: string = '';
  private selectedForSuspend: any;
  selectedSupend: any;

  // Pour rejet
  displayRejectDialog = false;
  rejectReason = '';
  private selectedForReject: any;
  constructor(

    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService


  ) {
    this.user_reference = this.localstorage.getUsers().data.reference;
    console.log("this.user_reference", this.user_reference);
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.getListeAdministrateur();
    });
  }

  ngOnInit() {

  }
  openModal() {
    this.modalService.open(AddAdministrateursComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  editOpenModal(item: any) {
    this.localstorage.saveAdministrateur(item);
    this.modalService.open(UpdateAdministrateurComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }


  getListeAdministrateur() {
    this.isLoading = true;

    this.authService.getAdministrateur(this.user_reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length; // Met à jour le total des enregistrements
        this.updatePaginated();

        console.log("la reponse du webservice", this.items);

      },
      (error) => {
        console.log("une erreu est survenu", error);

      }
    )
  }
  onPageChange(event) {
    this.first = event.first; // Mise à jour de la page actuelle
    this.rows = event.rows; // Mise à jour de la page actuelle
    this.updatePaginated();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }


  confirmSuppression(item: any) {
    console.log("item", item);

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir supprimer  :' + item?.nom + '?',

      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui', // Définir le libellé du bouton "Oui"
      rejectLabel: 'Non', // Définir le libellé du bouton "Non"
      accept: () => {
        this.ngxService.start();
        const requestData = {
          superadmin_id: this.user_reference
        }
        this.authService.deleteAdministrateur(item.reference, requestData).subscribe(

          (response: any) => {
            //console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });
            this.getListeAdministrateur();
            this.ngxService.stop();

          },
          (error) => {

            //console.log("une erreur est survenu",error);
            this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail: error.message });
            this.ngxService.stop();

          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: Constant.suiviTitle, detail: 'La suppression du programme est annulée.', life: 3000 });
      // }
    });
  }

  prepareSuspend(item: any) {
    this.selectedForSuspend = item;
    this.suspendReason = '';
    this.displaySuspendDialog = true;
  }

  // si annulation
  onCancelSuspend() {
    this.displaySuspendDialog = false;
    this.selectedForSuspend = null;
    this.suspendReason = '';
  }
  suspendAdmin() {
    console.log("item.reference", this.selectedForSuspend.reference);

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir suspendre  :' + this.selectedForSuspend?.nom + '?',

      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui', // Définir le libellé du bouton "Oui"
      rejectLabel: 'Non', // Définir le libellé du bouton "Non"
      accept: () => {
        this.ngxService.start();
        const requestData = {
        user_reference:this.selectedForSuspend?.reference, 
        admin_reference: this.user_reference,
          statut:'suspens',
          motif:this.suspendReason,
        }
        this.authService.changeAdministrateurStatus(requestData).subscribe(

          (response: any) => {
            //console.log("la reponse du webserice",response);
            this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });
            this.getListeAdministrateur();
            this.ngxService.stop();
            this.displaySuspendDialog = false;

          },
          (error) => {

            //console.log("une erreur est survenu",error);
            this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail: error.message });
            this.ngxService.stop();

          },
        )
      },
      // reject: () => {
      //     this.messageService.add({ severity: 'warn', summary: Constant.suiviTitle, detail: 'La suppression du programme est annulée.', life: 3000 });
      // }
    });
  }


  //

  validerAdministrateur(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir valider : ' + item?.nom + ' ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        const requestData = {
       user_reference:item?.reference, 
        admin_reference: this.user_reference,
          statut:'valide'
        };
        this.authService.changeAdministrateurStatus(requestData).subscribe(
          (response: any) => {
            this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });
            this.getListeAdministrateur();
            this.ngxService.stop();
          },
          (error) => {
            this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail: error.message });
            this.ngxService.stop();
          }
        );
      }
    });
  }

  reactiverAdministrateur(item: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir réactiver : ' + item?.nom + ' ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-refresh',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        const requestData = {
         user_reference:item.reference, 
         admin_reference: this.user_reference,
          statut:'valide'
        };
        this.authService.changeAdministrateurStatus(requestData).subscribe(
          (response: any) => {
            this.messageService.add({ severity: 'success', summary: "Ikena Cooperative", detail: response.message });
            this.getListeAdministrateur();
            this.ngxService.stop();
          },
          (error) => {
            this.messageService.add({ severity: 'error', summary: "Ikena Cooperative", detail: error.message });
            this.ngxService.stop();
          }
        );
      }
    });
  }

  prepareReject(item: any) {
    this.selectedForReject = item;
    this.rejectReason = '';
    this.displayRejectDialog = true;
  }

  onCancelReject() {
    this.displayRejectDialog = false;
    this.selectedForReject = null;
    this.rejectReason = '';
  }

  onConfirmReject() {
    if (!this.selectedForReject) return;
    this.displayRejectDialog = false;
    this.ngxService.start();
    const body = {
      user_reference:this.selectedForReject?.reference, 
      admin_reference: this.user_reference,
      motif: this.rejectReason.trim(),
      statut:'rejet'
    };
    this.authService
      .rejeterAdministrateur(body)
      .subscribe(
        resp => {
          this.messageService.add({ severity: 'success', detail: resp.message });
          this.getListeAdministrateur();
          this.ngxService.stop();
        },
        err => {
          this.messageService.add({ severity: 'error', detail: err.message });
          this.ngxService.stop();
        }
      );
    this.selectedForReject = null;
    this.rejectReason = '';
  }

  // … tes autres méthodes (valider, reactiver, supprimer, etc.) …


  //end
  filterBySearchTerm() {
    if (!this.searchTerm) {
      this.filteredtems = this.items; // Si la recherche est vide, affiche tous les éléments
    } else {
      const search = this.searchTerm.toLowerCase();

      this.filteredtems = this.items.filter(item =>
        (item?.nom && item.nom.toLowerCase().includes(search)) ||
        (item?.prenom && item.prenom.toLowerCase().includes(search)) ||
        (item?.email && item.email.toLowerCase().includes(search)) ||
        (item?.telephone && item.telephone.toLowerCase().includes(search))
      );
    }

    this.updatePaginated(); // Mise à jour de la pagination après filtrage
  }

  getLibelleStatut(statut: string): string {
    switch (statut) {
      case 'valide':
        return 'Actif';
      case 'suspens':
        return 'Suspendu';
      case 'pending':
        return 'En attente de validation';
         case 'rejet':
        return 'Rejeté';
      default:
        return 'Statut inconnu';
    }
  }

}
